import {ModuleRouteManifest} from '../types'

export const academicWorkloadRouteManifest: ModuleRouteManifest = {
  code: 'academic-workload',
  privateRoutes: [
    'periodloadcounter/*',
    'additional-teaching',
    'additional-teaching-calculations',
    'applied-education-visits',
  ],
}
